module.exports = __webpack_public_path__ + "img/1347_v5.a2365501.png";